import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Router } from "./routes/Router";
import "./styles/app.css";

const root = document.getElementById("root");
if (!root) throw new Error("root element missing");
createRoot(root).render(
  <StrictMode>
    <Router />
  </StrictMode>,
);
